import { useRef } from "react";
import { createPortal } from "react-dom";
import "react-toastify/dist/ReactToastify.css";

const Background = {
  width: "100%",
  height: "100%",
  left: "0",
  top: "0",
  position: "fixed",
  backgroundColor: "rgba(0,0,0,0.7)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: "10000",
};

const ModalWrapper = {
  boxShadow: "0 5px 16px rgba(0, 0, 0, 0.2)",
  color: "#000",
  position: "relative",
  width: "40%",
  zIndex: "10",
  borderRadius: "10px",
};

const Modal = ({ show, close, children }) => {
  const modalRef = useRef();
  const closeModal = (e) => {
    if (modalRef.current === e.target) {
      close();
    }
  };

  return createPortal(
    <>
      {show ? (
        <>
          <div
            className=""
            onClick={closeModal}
            ref={modalRef}
            style={Background}
          >
            <div className="wrapper_modal" style={ModalWrapper}>
              {children}
            </div>
          </div>
        </>
      ) : null}
    </>,

    document.getElementById("modal")
  );
};

export default Modal;
